import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { useSeo } from '../../lib/seo';

type TabType = 'corporate' | 'exhibition' | 'cm' | 'live' | 'drama' | 'composition' | 'film' | 'education' | 'produce' | 'tv' | 'tech' | 'interview';

interface GroupLink {
  label: string;
  url: string;
}

interface WorkItem {
  id: string;
  url: string;
  title?: string;
  note?: string;
  isPlaylist?: boolean;
  isExternal?: boolean;
  externalLabel?: string;
  image?: string;
  isGroup?: boolean;
  groupLinks?: GroupLink[];
}

const corporateVideos: WorkItem[] = [
  {
    id: 'FEj9KGck9RI',
    url: 'https://www.youtube.com/watch?v=FEj9KGck9RI&t=133s',
    title: '株式会社フタバロジコム 会社案内',
  },
  {
    id: 'yomiuri-osaka-viewing',
    url: '',
    isExternal: true,
    title: '読売新聞 大阪 見学者用動画',
    note: '非公開動画',
    externalLabel: '非公開',
  },
  {
    id: 'kamiiso-100th',
    url: '',
    isExternal: true,
    title: 'カミイソ株式会社 100周年記念ビデオ',
    note: '非公開動画',
    externalLabel: '非公開',
  },
  {
    id: 'k0gNX_2Q-Q0',
    url: 'https://www.youtube.com/watch?v=k0gNX_2Q-Q0',
    title: '佐川印刷 根付館',
  },
  { id: 'p70zuPKNMf4', url: 'https://www.youtube.com/watch?v=p70zuPKNMf4' },
  { id: 'JQ0Ry31flkk', url: 'https://www.youtube.com/watch?v=JQ0Ry31flkk', title: '【大成建設】DXで変わる働き方~2030年の現場(陸上土木編)' },
  { id: 'H1nNKcljJwo', url: 'https://www.youtube.com/watch?v=H1nNKcljJwo', title: '【大成建設】DXで変わる働き方~2030年の現場(鉄道工事編)~' },
  { id: '2JXvF1F4OyY', url: 'https://www.youtube.com/watch?v=2JXvF1F4OyY', title: '阪急阪神不動産 ジオ阪急川西 The Front' },
  { id: 'dT-dv5hwRJE', url: 'https://www.youtube.com/watch?v=dT-dv5hwRJE', title: '阪急阪神不動産 2026 会社案内（英語版）' },
  { id: 'deQFmOOcuIM', url: 'https://www.youtube.com/watch?v=deQFmOOcuIM' },
  { id: 'Emb-Eipeew8', url: 'https://www.youtube.com/watch?v=Emb-Eipeew8' },
  { id: 'njDINtt4gZM', url: 'https://www.youtube.com/watch?v=njDINtt4gZM' },
  { id: '-eDWfjEmO_w', url: 'https://www.youtube.com/watch?v=-eDWfjEmO_w' },
  { id: 'AXf57NGYVP4', url: 'https://www.youtube.com/watch?v=AXf57NGYVP4', title: '光洋サーモ SmartFLEC' },
  { id: 'eKHLccTz2KE', url: 'https://www.youtube.com/watch?v=eKHLccTz2KE', title: '参天製薬 能登工場見学' },
  { id: 'JdQom9Fbf64', url: 'https://www.youtube.com/watch?v=JdQom9Fbf64', title: '金正青果 50周年式典用映像 信念の50年' },
  { id: 'skL8NRDzwh0', url: 'https://www.youtube.com/watch?v=skL8NRDzwh0' },
  { id: 'eCbBJpuTiEk', url: 'https://www.youtube.com/watch?v=eCbBJpuTiEk', title: '但馬牛博物館 プロジェクションマッピング映像' },
  { id: 'O8ORdUi4HOc', url: 'https://www.youtube.com/watch?v=O8ORdUi4HOc', title: 'Kawasaki Machine Systems 会社案内' },
  { id: 'x0bcSx42m0s', url: 'https://www.youtube.com/watch?v=x0bcSx42m0s', title: 'コベルコ科研 会社案内+リクルート編' },
  { id: '7qs-wqMqqyo', url: 'https://www.youtube.com/watch?v=7qs-wqMqqyo' },
  { id: 'Fz5w9U_rSlE', url: 'https://www.youtube.com/watch?v=Fz5w9U_rSlE' },
  { id: 't-aq2cGFjBI', url: 'https://www.youtube.com/watch?v=t-aq2cGFjBI' },
  { id: 'mgvn5xeNBmQ', url: 'https://www.youtube.com/watch?v=mgvn5xeNBmQ' },
  { id: 'pwl448Ajkck', url: 'https://www.youtube.com/watch?v=pwl448Ajkck', title: 'ゆめ・まちSDGsドリル2024 初級&中級編 解説動画' },
  { id: '8kt9lO7PL0I', url: 'https://www.youtube.com/watch?v=8kt9lO7PL0I' },
  { id: 'ijOXM8UtHD8', url: 'https://www.youtube.com/watch?v=ijOXM8UtHD8' },
  { id: 'JLGjISDJ9sY', url: 'https://www.youtube.com/watch?v=JLGjISDJ9sY' },
  { id: 'TXN8iMefols', url: 'https://www.youtube.com/watch?v=TXN8iMefols' },
  {
    id: 'nexco-fct',
    url: 'https://www.w-nexco-fct.co.jp/products/item02.html',
    isExternal: true,
    externalLabel: 'サイトで確認',
  },
  { id: '3xSPPGiN9FE', url: 'https://www.youtube.com/watch?v=3xSPPGiN9FE' },
  {
    id: 'zRw8mbeDnCM',
    url: 'https://www.youtube.com/watch?v=zRw8mbeDnCM',
    title: 'フジ医療器 AS-R2300',
    note: 'フジ医療器公式チャンネル掲載中の多数動画に参加',
  },
  {
    id: 'fujiiryoki-channel',
    url: 'https://www.youtube.com/@FujiiryokiMovie',
    isExternal: true,
    externalLabel: 'チャンネルを見る',
    title: 'フジ医療器公式 YouTubeチャンネル',
    note: '掲載中の多数動画に参加',
  },
  {
    id: 'hankyu-hanshin-group',
    url: '',
    title: '阪急阪神ビルマネジメント様',
    isGroup: true,
    groupLinks: [
      { label: '動画 ①', url: 'https://www.youtube.com/watch?v=lbosTYPTET0' },
      { label: '動画 ②', url: 'https://www.youtube.com/watch?v=Xy_mODdTQqw' },
      { label: '動画 ③', url: 'https://www.youtube.com/watch?v=u9yGUWX2csA' },
      { label: '動画 ④', url: 'https://www.youtube.com/watch?v=72dngflb47E' },
    ],
  },
  {
    id: 'oRION-DzHuQ',
    url: 'https://www.youtube.com/watch?v=oRION-DzHuQ&t=1s',
    title: '(株)アストライン',
    note: '就職活動中の皆さまへ',
  },
  {
    id: 'jcca-infra70',
    url: 'https://www.jcca.or.jp/infra70n/files/chirashi_NO69.pdf',
    isExternal: true,
    externalLabel: 'PDFで確認',
    title: '（一社）建設コンサルタンツ協会',
    note: 'インフラ整備70年講演会（第69回）',
  },
];

const exhibitionItems: WorkItem[] = [
  {
    id: 'samurai-ninja-museum',
    url: 'https://www.samuraimuseum.jp/index.html',
    isExternal: true,
    title: 'サムライニンジャミュージアム 東京',
    note: 'EXHIBITION（効果音 MIX を担当）',
    externalLabel: 'サイトで確認',
  },
  {
    id: 'semba-mural-park',
    url: 'https://www.semba-center.com/smp/',
    isExternal: true,
    title: '「船場ミューラルパーク」',
    note: 'プロジェクションマッピング（サラウンド）',
    externalLabel: 'サイトで確認',
  },
  {
    id: 'denki-kagakukan',
    url: 'https://www.chuden.co.jp/e-museum/facility/chikyu_energy/',
    isExternal: true,
    title: 'でんきの科学館',
    note: '3階「環境とエネルギー」のリニューアルを担当',
    externalLabel: 'サイトで確認',
  },
  {
    id: 'soramiru',
    url: 'https://www.soramiru.jp/',
    isExternal: true,
    title: '宇宙ふれあいホール Sora-Miru',
    externalLabel: 'サイトで確認',
  },
  {
    id: 'ImL2SRuXFrE',
    url: 'https://www.youtube.com/watch?v=ImL2SRuXFrE',
    title: '【畦地梅太郎】が手掛けたブックデザイン（愛媛県美術館）',
    note: 'MIXを担当',
  },
];

const cmVideos: WorkItem[] = [
  { id: 'abd8lgW8_eA', url: 'https://www.youtube.com/watch?v=abd8lgW8_eA' },
  { id: 'rGIMdvcvk8E', url: 'https://www.youtube.com/watch?v=rGIMdvcvk8E' },
  {
    id: 'playlist-cm',
    url: 'https://www.youtube.com/playlist?list=PLD3UPyh7P63pYgicAC_WiCn8GwNVKw8Lu',
    isPlaylist: true,
    note: '撮影 MA などトータルに参加',
  },
  { id: 'tMueRyf-DZ8', url: 'https://www.youtube.com/watch?v=tMueRyf-DZ8', note: '撮影 MA などトータルに参加' },
  { id: 'fQS_k2035Mw', url: 'https://www.youtube.com/watch?v=fQS_k2035Mw', note: '撮影 MA などトータルに参加' },
  { id: '9-kr8X3w5hE', url: 'https://www.youtube.com/watch?v=9-kr8X3w5hE', note: '撮影 MA などトータルに参加' },
  { id: 'SvoNEeoA9sU', url: 'https://www.youtube.com/watch?v=SvoNEeoA9sU', note: '撮影に参加' },
  { id: 'lbosTYPTET0', url: 'https://www.youtube.com/watch?v=lbosTYPTET0', note: '撮影に参加' },
  { id: 'jXLbBvVOm7M', url: 'https://www.youtube.com/watch?v=jXLbBvVOm7M', note: '撮影に参加' },
  { id: 'tab4PwSA1uo', url: 'https://www.youtube.com/watch?v=tab4PwSA1uo', note: '撮影に参加' },
  {
    id: 'lab-ms-cm',
    url: 'https://lab-ms.com/achievement/%e3%83%86%e3%82%b9%e3%83%88/',
    isExternal: true,
    externalLabel: 'サイトで確認',
    note: '撮影に参加',
  },
  { id: 'ykwNFpsiXpg', url: 'https://www.youtube.com/watch?v=ykwNFpsiXpg' },
  { id: '9SDdCqXFU38', url: 'https://www.youtube.com/watch?v=9SDdCqXFU38' },
  { id: 'tnngYFseZUg', url: 'https://www.youtube.com/watch?v=tnngYFseZUg' },
  { id: 'ot6XhBPyxdI', url: 'https://www.youtube.com/watch?v=ot6XhBPyxdI' },
  {
    id: '-hF-MorEn0E',
    url: 'https://www.youtube.com/watch?v=-hF-MorEn0E',
    title: 'Rise of the Ronin ローンチトレーラー',
    note: '出張録音 ｜ イギリスチーム制作指揮のもと、京都の某撮影所にて録音担当。夜間、雪の降る中での撮影でした。',
  },
  {
    id: 'suntory-iemon-group',
    url: '',
    title: 'サントリー 伊右衛門',
    note: '撮影 山下 敦弘 ｜ 1日で京都5ヶ所を巡る撮影でした。',
    isGroup: true,
    groupLinks: [
      { label: 'バッテリイズ「親の教え」編', url: 'https://www.youtube.com/watch?v=HcO1g33coEo' },
      { label: 'バッテリイズ「心のふるさと」編', url: 'https://www.youtube.com/watch?v=FjROfaRA6r0' },
      { label: 'バッテリイズ「歯磨き」篇', url: 'https://www.youtube.com/watch?v=SYm18LVh9LQ' },
      { label: 'バッテリィズ「悟り」篇', url: 'https://www.youtube.com/watch?v=h3piomXgD1g' },
      { label: '「しりとり」篇', url: 'https://www.youtube.com/watch?v=N3XHKZ2V_Qw' },
    ],
  },
];

const liveVideos: WorkItem[] = [
  {
    id: 'Xxv08z0SyHk',
    url: 'https://www.youtube.com/watch?v=Xxv08z0SyHk',
    note: '当日会場で流れたVTRも担当しました',
  },
  {
    id: 'WisaeSZBaB8',
    url: 'https://www.youtube.com/watch?v=WisaeSZBaB8',
    note: '当日会場で流れたVTRも担当しました',
  },
];

const dramaVideos: WorkItem[] = [
  {
    id: 'cgHO0FaVtZQ',
    url: 'https://www.youtube.com/shorts/cgHO0FaVtZQ',
    title: '豊中市介護保険事業者連絡会 Episode01',
  },
  {
    id: '59qXWFObY1A',
    url: 'https://www.youtube.com/shorts/59qXWFObY1A',
    title: '豊中市介護保険事業者連絡会 Episode02',
  },
  {
    id: 'BpOliAhTIRY',
    url: 'https://www.youtube.com/shorts/BpOliAhTIRY',
    title: '豊中市介護保険事業者連絡会 Episode03',
  },
  {
    id: 'GmP0zXXmU8c',
    url: 'https://www.youtube.com/shorts/GmP0zXXmU8c',
    title: '豊中市介護保険事業者連絡会 Episode04',
  },
  {
    id: 'AHna89OQQ-c',
    url: 'https://www.youtube.com/shorts/AHna89OQQ-c',
    title: '豊中市介護保険事業者連絡会 Episode05',
  },
  {
    id: '6pEryIzBi8I',
    url: 'https://www.youtube.com/shorts/6pEryIzBi8I',
    title: '豊中市介護保険事業者連絡会 Episode06',
  },
];

interface FilmItem {
  title: string;
  url: string;
  isExternal?: boolean;
  isYoutube?: boolean;
}

interface FilmDirector {
  director: string;
  role: string;
  films: FilmItem[];
}

const filmDirectors: FilmDirector[] = [
  {
    director: '溝口尚美監督',
    role: '音効・整音 担当',
    films: [
      { title: 'グローバルダリッド', url: '' },
    ],
  },
  {
    director: '田中幸夫監督',
    role: '録音・整音 助手として参加',
    films: [
      { title: '淀川アジール　さどヤンの生活と意見', url: 'https://eiga.com/movie/94913/', isExternal: true },
      { title: '女になる', url: 'https://eiga.com/movie/87595/', isExternal: true },
      { title: '徘徊　ママリン87歳の夏', url: 'https://eiga.com/movie/82059/', isExternal: true },
      { title: 'ITECHO 凍蝶圖鑑', url: 'https://eiga.com/movie/81180/', isExternal: true },
      { title: 'Shunji あるヘアデザイナーの物語', url: 'https://www.youtube.com/watch?v=jWvxi7-exBk', isYoutube: true },
      { title: '未来世紀ニシナリ', url: 'https://eiga.com/movie/54460/', isExternal: true },
      { title: '神様たちの街', url: 'https://eiga.com/movie/84871/', isExternal: true },
    ],
  },
  {
    director: '溝渕雅幸監督',
    role: '録音・整音 助手として参加',
    films: [
      { title: '結びの島', url: 'https://eiga.com/movie/93791/', isExternal: true },
      { title: '四万十　いのちの仕舞い', url: 'https://eiga.com/movie/88436/', isExternal: true },
      { title: 'いのちがいちばん輝く日　あるホスピス病棟の40日', url: '' },
    ],
  },
];


const compositionVideos: WorkItem[] = [
  {
    id: 'pRqWBZjFoWo',
    url: 'https://www.youtube.com/watch?v=pRqWBZjFoWo',
    title: '辻岡歯科',
    note: 'サウンドロゴ｜作曲打ち合わせ 歌収録 納品まで担当',
  },
];

const tvVideos: WorkItem[] = [
  {
    id: '8GOOCSZB-DM',
    url: 'https://www.youtube.com/watch?v=8GOOCSZB-DM&t=222s',
    title: "WIB HERO'S〜和歌山から生まれる 未来を変える主役たち〜",
    note: '音効担当',
  },
];

const interviewItems: WorkItem[] = [
  {
    id: 'rockonpro-galileoclub',
    url: 'https://pro.miroc.co.jp/works/galileoclub/',
    isExternal: true,
    externalLabel: '記事を見る',
    title: 'ROCK ON PRO 取材記事',
    note: 'ガリレオクラブ時代に ROCK ON PRO様の取材を受けました',
  },
];

const techVideos: WorkItem[] = [
  {
    id: 'expo2025-interview',
    url: 'https://www.youtube.com/results?search_query=%E4%B8%87%E5%8D%9A%E3%82%A4%E3%83%B3%E3%82%BF%E3%83%93%E3%83%A5%E3%83%BC',
    isExternal: true,
    externalLabel: 'YouTubeで見る',
    title: '2025大阪関西万博 公式インタビュー',
    note: '収録を音声技術として参加',
  },
];

const produceVideos: WorkItem[] = [
  {
    id: 'xLuoX2bjXYM',
    url: 'https://www.youtube.com/watch?v=xLuoX2bjXYM',
    title: '近畿刃物工業株式会社 60周年記念 会社案内',
    note: '近畿刃物工業株式会社 ６０周年を記念して作成された、会社案内をプロデュースいたしました。',
  },
  {
    id: 'wrZWuMUA1uM',
    url: 'https://www.youtube.com/watch?v=wrZWuMUA1uM',
    title: '近畿刃物工業株式会社 60周年記念 会社案内',
    note: '近畿刃物工業株式会社 ６０周年を記念して作成された、会社案内をプロデュースいたしました。',
  },
];

const educationVideos: WorkItem[] = [
  {
    id: 'yomiuri-selection',
    url: 'https://www.youtube.com/channel/UCaxxPS1GTPkSNzs0cYWDIpw/videos',
    isExternal: true,
    title: '読売進学セレクション',
    note: '歴代の音楽を担当しています。',
    externalLabel: 'YouTubeチャンネルを見る',
  },
  {
    id: 'mF6M7tLgFz8',
    url: 'https://www.youtube.com/watch?v=mF6M7tLgFz8',
    title: 'Vol.1 「和歌山の豊かな自然・つながる生物」',
    note: 'きのくに いきもののくに おしえて くまぐす先生！！',
  },
  {
    id: 'tDG1C8yRjp8',
    url: 'https://www.youtube.com/watch?v=tDG1C8yRjp8',
    title: 'Vol.2 「発見！近くにある生き物の世界」',
    note: 'きのくに いきもののくに おしえて くまぐす先生！！',
  },
  {
    id: 'XexmTOiRppI',
    url: 'https://www.youtube.com/watch?v=XexmTOiRppI',
    title: 'Vol.3 「里地・里山・里海　～私たちと生き物が作る環境～」',
    note: 'きのくに いきもののくに おしえて くまぐす先生！！',
  },
  {
    id: 'bBzTMez0diY',
    url: 'https://www.youtube.com/watch?v=bBzTMez0diY',
    title: 'Vol.4 「外来種について考えよう！」',
    note: 'きのくに いきもののくに おしえて くまぐす先生！！',
  },
  {
    id: 'oCGNNTvvib4',
    url: 'https://www.youtube.com/watch?v=oCGNNTvvib4',
    title: 'Vol.5 「生物多様性って？～「わかやま」の名を持つ生き物～」',
    note: 'きのくに いきもののくに おしえて くまぐす先生！！',
  },
  {
    id: 'eDlMzA4aKrA',
    url: 'https://www.youtube.com/watch?v=eDlMzA4aKrA',
    title: 'Vol.6 「気になる自然！和歌山探検ガイド」',
    note: 'きのくに いきもののくに おしえて くまぐす先生！！',
  },
];

const tabConfig: { key: TabType; label: string; icon: string }[] = [
  { key: 'corporate', label: '企業様', icon: 'ri-building-line' },
  { key: 'exhibition', label: '展示', icon: 'ri-gallery-line' },
  { key: 'cm', label: 'CM', icon: 'ri-tv-2-line' },
  { key: 'live', label: 'ライブ配信 アーカイブ', icon: 'ri-live-line' },
  { key: 'drama', label: '縦型ドラマ', icon: 'ri-film-line' },
  { key: 'film', label: '映画', icon: 'ri-movie-2-line' },
  { key: 'composition', label: '作曲', icon: 'ri-music-2-line' },
  { key: 'education', label: '教育', icon: 'ri-book-open-line' },
  { key: 'produce', label: 'プロデュース', icon: 'ri-vip-diamond-line' },
  { key: 'tv', label: 'TV', icon: 'ri-tv-line' },
  { key: 'tech', label: '撮影 音声（技術）', icon: 'ri-mic-line' },
  { key: 'interview', label: '取材', icon: 'ri-newspaper-line' },
];


function getThumbnailUrl(item: WorkItem): string {
  if (item.image) {
    return item.image;
  }
  if (item.isExternal || item.isPlaylist) {
    return '';
  }
  return `https://img.youtube.com/vi/${item.id}/hqdefault.jpg`;
}

function WorkCard({ item, index, tabLabel }: { item: WorkItem; index: number; tabLabel: string }) {
  const thumbUrl = getThumbnailUrl(item);
  const isYoutube = !item.isExternal && !item.isPlaylist && !item.image;

  return (
    <div className="bg-white rounded-lg overflow-hidden hover:shadow-xl transition-shadow border border-gray-100">
      <div className="relative w-full h-48 bg-gray-100 flex items-center justify-center overflow-hidden">
        {thumbUrl ? (
          <>
            <img
              src={thumbUrl}
              alt={item.title ?? `${tabLabel} #${index + 1}`}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-black/20 hover:bg-black/10 transition-colors"></div>
          </>
        ) : item.isPlaylist ? (
          <div className="flex flex-col items-center justify-center w-full h-full bg-gradient-to-br from-teal-50 to-teal-100">
            <div className="w-14 h-14 flex items-center justify-center">
              <i className="ri-play-list-2-line text-4xl text-teal-600"></i>
            </div>
            <span className="mt-2 text-sm text-teal-700 font-medium">プレイリスト</span>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center w-full h-full bg-gradient-to-br from-gray-50 to-gray-100">
            <div className="w-14 h-14 flex items-center justify-center">
              <i className="ri-links-line text-4xl text-gray-400"></i>
            </div>
            <span className="mt-2 text-sm text-gray-500 font-medium">外部サイト</span>
          </div>
        )}
      </div>
      <div className="p-5">
        <h3 className="text-sm font-semibold text-gray-700 mb-2">
          {item.title ?? `${tabLabel} #${index + 1}`}
        </h3>
        {item.note && (
          <span className="inline-block bg-teal-50 text-teal-700 text-xs px-2 py-1 rounded-full mb-3 font-medium">
            {item.note}
          </span>
        )}
        <div>
          {item.isGroup && item.groupLinks ? (
            <div className="space-y-2">
              {item.groupLinks.map((link) => (
                <button
                  key={link.url}
                  onClick={() => window.open(link.url, '_blank')}
                  className="flex items-center text-teal-600 hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap font-medium text-sm w-full"
                >
                  <i className="ri-youtube-fill mr-2 text-base shrink-0"></i>
                  <span className="truncate">{link.label}</span>
                </button>
              ))}
            </div>
          ) : (
            <button
              onClick={() => item.url ? window.open(item.url, '_blank') : undefined}
              className={`flex items-center transition-colors whitespace-nowrap font-medium text-sm ${item.url ? 'text-teal-600 hover:text-teal-700 cursor-pointer' : 'text-gray-400 cursor-default'}`}
            >
              {isYoutube ? (
                <>
                  <i className="ri-youtube-fill mr-2 text-lg"></i>
                  {item.isPlaylist ? 'プレイリストで視聴' : 'YouTubeで視聴'}
                </>
              ) : (
                <>
                  <i className="ri-external-link-line mr-2 text-lg"></i>
                  {item.externalLabel ?? 'サイトで確認'}
                </>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

function FilmSection() {
  return (
    <div className="space-y-12">
      {filmDirectors.map((director) => (
        <div key={director.director} className="bg-white border border-gray-100 rounded-lg overflow-hidden">
          <div className="bg-gradient-to-r from-teal-600 to-teal-500 px-8 py-5">
            <h2 className="text-xl font-bold text-white mb-1">{director.director}</h2>
            <span className="inline-block bg-white/20 text-white text-xs px-3 py-1 rounded-full font-medium">
              {director.role}
            </span>
          </div>
          <div className="p-6">
            {director.films.length === 0 ? (
              <p className="text-gray-400 text-sm italic">作品情報 準備中</p>
            ) : (
              <ul className="space-y-3">
                {director.films.map((film) => (
                  <li key={film.title} className="flex items-center justify-between group">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 flex items-center justify-center">
                        <i className={`${film.isYoutube ? 'ri-youtube-fill text-red-500' : film.isExternal ? 'ri-film-fill text-teal-500' : 'ri-film-line text-gray-400'} text-xl`}></i>
                      </div>
                      <span className="text-gray-700 font-medium text-sm">{film.title}</span>
                    </div>
                    {film.url && (
                      <button
                        onClick={() => window.open(film.url, '_blank')}
                        className="flex items-center gap-1 text-xs text-teal-600 hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap font-medium ml-4 shrink-0"
                      >
                        {film.isYoutube ? (
                          <>
                            <i className="ri-youtube-fill"></i>
                            YouTubeで視聴
                          </>
                        ) : (
                          <>
                            <i className="ri-external-link-line"></i>
                            {film.isExternal ? '映画.comで確認' : '詳細を見る'}
                          </>
                        )}
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

function EducationSection() {
  return (
    <div>
      <div className="text-center mb-8">
        <p className="text-gray-700 font-semibold text-base mb-1">きのくに いきもののくに おしえて くまぐす先生！！</p>
        <p className="text-gray-500 text-sm">3年に渡り制作した作品です。和歌山の自然な音を収録しに行き、よりリアルな音を子供たちに聞いてもらえる工夫をしました。</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {educationVideos.map((video, idx) => (
          <div
            key={video.id}
            className="bg-white rounded-lg overflow-hidden hover:shadow-xl transition-shadow border border-gray-100 cursor-pointer group"
            onClick={() => window.open(video.url, '_blank')}
          >
            <div className="relative w-full h-48 bg-gray-100 overflow-hidden">
              <img
                src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                alt={video.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                <div className="w-12 h-12 flex items-center justify-center bg-white/80 rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-play-fill text-teal-600 text-2xl"></i>
                </div>
              </div>
              <div className="absolute top-2 left-2 bg-teal-600 text-white text-xs font-bold px-2 py-1 rounded-full">
                Vol.{idx + 1}
              </div>
            </div>
            <div className="p-5">
              <h3 className="text-sm font-semibold text-gray-700 mb-2">{video.title}</h3>
              <span className="inline-block bg-teal-50 text-teal-700 text-xs px-2 py-1 rounded-full mb-3 font-medium">
                {video.note}
              </span>
              <div>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(video.url, '_blank');
                  }}
                  className="flex items-center text-teal-600 hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap font-medium text-sm"
                >
                  <i className="ri-youtube-fill mr-2 text-lg"></i>
                  YouTubeで視聴
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function WorksSecretPage() {
  useSeo({
    title: '制作実績(限定公開) | 合同会社WakuWaku',
    description: '関係者限定の制作実績ページです。',
    path: '/works-secret/',
    noindex: true,
  });

  const [isUnlocked, setIsUnlocked] = useState(false);
  const [password, setPassword] = useState('');
  const [showError, setShowError] = useState(false);
  const [activeTab, setActiveTab] = useState<TabType>('corporate');

  const handlePasswordSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password.toUpperCase() === 'WAKUWAKU') {
      setIsUnlocked(true);
      setShowError(false);
    } else {
      setShowError(true);
      setPassword('');
    }
  };

  const getVideos = (): WorkItem[] => {
    switch (activeTab) {
      case 'corporate': return corporateVideos;
      case 'exhibition': return exhibitionItems;
      case 'cm': return cmVideos;
      case 'live': return liveVideos;
      case 'drama': return dramaVideos;
      case 'composition': return compositionVideos;
      case 'film': return [];
      case 'education': return educationVideos;
      case 'produce': return produceVideos;
      case 'tv': return tvVideos;
      case 'tech': return techVideos;
      case 'interview': return interviewItems;
      default: return corporateVideos;
    }
  };

  const getTabLabel = (): string => {
    return tabConfig.find((t) => t.key === activeTab)?.label ?? '';
  };

  const currentVideos = getVideos();
  const totalFilmCount = filmDirectors.reduce((acc, d) => acc + d.films.length, 0);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />

      <main className="flex-grow">
        <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-16">
                <h1 className="text-4xl font-bold text-gray-800 mb-6">制作実績アーカイブ</h1>
                <div className="w-20 h-1 bg-teal-600 mx-auto mb-6"></div>
                <p className="text-gray-600 text-lg">これまでに制作した作品の一覧です</p>
              </div>

              {!isUnlocked ? (
                <div className="bg-white border-2 border-gray-200 rounded-lg p-12">
                  <div className="max-w-md mx-auto">
                    <div className="text-center mb-8">
                      <i className="ri-lock-line text-6xl text-teal-600 mb-6"></i>
                      <h2 className="text-2xl font-semibold text-gray-800 mb-4">アクセス制限</h2>
                      <p className="text-gray-600">このページの閲覧にはパスワードが必要です</p>
                    </div>

                    <form onSubmit={handlePasswordSubmit} className="space-y-4">
                      <div>
                        <input
                          type="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder="パスワードを入力"
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-center text-base"
                        />
                      </div>
                      {showError && (
                        <p className="text-red-600 text-sm text-center">パスワードが正しくありません</p>
                      )}
                      <Button type="submit" variant="primary" className="w-full whitespace-nowrap">
                        <i className="ri-key-line mr-2"></i>
                        アクセス
                      </Button>
                    </form>
                  </div>
                </div>
              ) : (
                <div>
                  <div className="flex justify-center mb-12">
                    <div className="inline-flex bg-gray-100 rounded-full p-1 flex-wrap gap-1">
                      {tabConfig.map((tab) => (
                        <button
                          key={tab.key}
                          onClick={() => setActiveTab(tab.key)}
                          className={`px-6 py-3 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer text-sm ${
                            activeTab === tab.key
                              ? 'bg-teal-600 text-white'
                              : 'text-gray-600 hover:text-gray-800'
                          }`}
                        >
                          <i className={`${tab.icon} mr-2`}></i>
                          {tab.label}
                        </button>
                      ))}
                    </div>
                  </div>

                  {activeTab === 'film' ? (
                    <>
                      <FilmSection />
                      <div className="mt-12 text-center">
                        <p className="text-gray-500 text-sm">
                          全 {totalFilmCount} 作品を表示中
                        </p>
                      </div>
                    </>
                  ) : activeTab === 'exhibition' ? (
                    <>
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {exhibitionItems.map((item, index) => (
                          <WorkCard
                            key={item.id}
                            item={item}
                            index={index}
                            tabLabel="展示"
                          />
                        ))}
                      </div>
                      <div className="mt-12 text-center">
                        <p className="text-gray-500 text-sm">
                          全 {exhibitionItems.length} 件を表示中
                        </p>
                      </div>
                    </>
                  ) : activeTab === 'education' ? (
                    <>
                      <EducationSection />
                      <div className="mt-12 text-center">
                        <p className="text-gray-500 text-sm">
                          全 {educationVideos.length} 作品を表示中
                        </p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {currentVideos.map((video, index) => (
                          <WorkCard
                            key={video.id}
                            item={video}
                            index={index}
                            tabLabel={getTabLabel()}
                          />
                        ))}
                      </div>
                      <div className="mt-12 text-center">
                        <p className="text-gray-500 text-sm">
                          全 {currentVideos.length} 作品を表示中
                        </p>
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
